import axios from 'axios';
//import MockAdapter from 'axios-mock-adapter'

//console.log("ENV--", process.env.REACT_APP_MOCK);

if(process.env.REACT_APP_MOCK){
  //const mock = new MockAdapter(axios);


/*

  mock.onGet("/api/v0/pratica/*").reply(200, {

  tmpCurrentStep: 0,
    
  modello:{

    id: "12312",
    codiceBroker: 'COD21302',
    currentStep: 1,

    datiPratica:{

        importo:15000,
        numeroRate:48,
        assicurazione:true,
        progetto:"MOT",
        tan:6.77,
        taeg:3.66,
        rata:30.65,
      
        nome:'Matteo',
        cognome:'Marescotti',
        codiceFiscale:'MRSMTT96T14D548A',
        consensoMkt:false,
        consensoTerzi:true,
        consensoMarketing:false,
      

        email:'',
        confermaEmail:'',
        cellulare:'',
        telefono:'',
      
        correntistaCcb:null,
        iban:'',
 

        personaEsposta:null,

        cittadinanza:'',
        tipoPermessoSoggiorno:'',
        dataScadenzaSoggiorno:'',
   

        statoCivile:'',


        abitazione:"",
        importoAffitto:"",
        indirizzoResidenza:"",
        civico:"",
        cap:"",
        comune:"",
        provincia:"",
        tempoResidenza:"",
        indirizzoResidenzaPrecedente:"",
        civicoPrecedente:"",
        capPrecedente:"",
        comunePrecedente:"",
        provinciaPrecedente:"",
  

        documento:'',
        numeroDocumento:'',
        dataEmissioneDocumento:'',
        comuneEmissione:'',
        provinciaEmissione:"",
      
        
        attivita:'',
        occupazioneAutonomo:'',
        occupazioneDipendente:'',
        tipologiaPensione:"",
        dataInizioAttivita:"",
        dataFineAttivita:"",
        settoreAttivita:"",
        tipoContratto:"",
        ragioneSocialeAzienda:"",
        indirizzoResidenzaAzienda:"",
        capAzienda:"",
        comuneAzienda:"",
        provinciaAzienda:"",
        telefonoAzienda:"",


        redditoMensileNetto:"",
        redditoMensilita:"",
      

        domanda1:null,
        domanda2:null,
        domanda3:null,
        domanda4:null,
        domanda5:null,
        questionarioCompletato:null
    
    }
  },

    cartaIdentita: {
      unico:false,
      fronte: {
        uid: '1',
        name: 'fronte.png',
        status: 'error',
        response: 'Server Error 500', // custom error message to show
        url: 'http://www.baidu.com/xxx.png',
      },
      retro: {
        uid: '1',
        name: 'retro.png',
        status: 'done',
        response: '', 
        url: 'http://www.baidu.com/xxx.png',
      }
    },

    tesserinoSanitario: {
      unico:true,
      fronte: {
        uid: '1',
        name: 'unico.png',
        status: 'error',
        response: 'Server Error 500', // custom error message to show
        url: 'http://www.baidu.com/xxx.png',
      },
      retro:{}
    },

    ModelloUnico: {
      unico:false
    }

  });


*/


/*

  mock.onPost("/api/v0/pratica").reply(200, {

    tmpCurrentStep: 0,

    modello:{

    id: "12312",
    codiceBroker: 'COD21302',
    currentStep: 1,

    datiPratica:{

        importo:15000,
        numeroRate:48,
        assicurazione:true,
        progetto:"RIS",
        tan:6.77,
        taeg:3.66,
        rata:30.65,
      
        nome:'',
        cognome:'',
        codiceFiscale:'',
        consensoMkt:null,
        consensoTerzi:null,
        consensoMarketing:null,
      

        email:'',
        confermaEmail:'',
        cellulare:'',
        telefono:'',
      
        correntistaCcb:null,
        iban:'',
 

        personaEsposta:null,

        cittadinanza:'',
        tipoPermessoSoggiorno:'',
        dataScadenzaSoggiorno:'',
   

        statoCivile:'',


        abitazione:"",
        importoAffitto:"",
        indirizzoResidenza:"",
        civico:"",
        cap:"",
        comune:"",
        provincia:"",
        tempoResidenza:"",
        indirizzoResidenzaPrecedente:"",
        civicoPrecedente:"",
        capPrecedente:"",
        comunePrecedente:"",
        provinciaPrecedente:"",
  

        documento:'',
        numeroDocumento:'',
        dataEmissioneDocumento:'',
        comuneEmissione:'',
        provinciaEmissione:"",
      
        
        attivita:'',
        occupazioneAutonomo:'',
        occupazioneDipendente:'',
        tipologiaPensione:"",
        dataInizioAttivita:"",
        dataFineAttivita:"",
        settoreAttivita:"",
        tipoContratto:"",
        ragioneSocialeAzienda:"",
        indirizzoResidenzaAzienda:"",
        capAzienda:"",
        comuneAzienda:"",
        provinciaAzienda:"",
        telefonoAzienda:"",


        redditoMensileNetto:"",
        redditoMensilita:"",
      

        domanda1:null,
        domanda2:null,
        domanda3:null,
        domanda4:null,
        domanda5:null,
        questionarioCompletato:null
    
    }

  }

  });
*/

/*

  mock.onPut("/api/v0/pratica/*").reply(200, {

    tmpCurrentStep: 0,

  
    modello:{
    
    id: "12312",
    codiceBroker: 'COD21302',
    currentStep: 1,

    datiPratica:{

        importo:15000,
        numeroRate:48,
        assicurazione:true,
        progetto:"RIS",
        tan:6.77,
        taeg:3.66,
        rata:30.65,
      
        nome:'Matteo',
        cognome:'Marescotti',
        codiceFiscale:'MRSMTT96T14D548A',
        consensoMkt:false,
        consensoTerzi:true,
        consensoMarketing:false,
      

        email:'',
        confermaEmail:'',
        cellulare:'',
        telefono:'',
      
        correntistaCcb:null,
        iban:'',
 

        personaEsposta:null,

        cittadinanza:'',
        tipoPermessoSoggiorno:'',
        dataScadenzaSoggiorno:'',
   

        statoCivile:'',


        abitazione:"",
        importoAffitto:"",
        indirizzoResidenza:"",
        civico:"",
        cap:"",
        comune:"",
        provincia:"",
        tempoResidenza:"",
        indirizzoResidenzaPrecedente:"",
        civicoPrecedente:"",
        capPrecedente:"",
        comunePrecedente:"",
        provinciaPrecedente:"",
  

        documento:'',
        numeroDocumento:'',
        dataEmissioneDocumento:'',
        comuneEmissione:'',
        provinciaEmissione:"",
      
        
        attivita:'',
        occupazioneAutonomo:'',
        occupazioneDipendente:'',
        tipologiaPensione:"",
        dataInizioAttivita:"",
        dataFineAttivita:"",
        settoreAttivita:"",
        tipoContratto:"",
        ragioneSocialeAzienda:"",
        indirizzoResidenzaAzienda:"",
        capAzienda:"",
        comuneAzienda:"",
        provinciaAzienda:"",
        telefonoAzienda:"",


        redditoMensileNetto:"",
        redditoMensilita:"",
      

        domanda1:null,
        domanda2:null,
        domanda3:null,
        domanda4:null,
        domanda5:null,
        questionarioCompletato:null
    
    }

  },

    cartaIdentita: {
      unico:false,
      fronte: {
        uid: '1',
        name: 'fronte.png',
        status: 'error',
        response: 'Server Error 500', // custom error message to show
        url: 'http://www.baidu.com/xxx.png',
      },
      retro: {
        uid: '1',
        name: 'retro.png',
        status: 'done',
        response: '', 
        url: 'http://www.baidu.com/xxx.png',
      }
    },

    tesserinoSanitario: {
      unico:true,
      fronte: {
        uid: '1',
        name: 'unico.png',
        status: 'error',
        response: 'Server Error 500', // custom error message to show
        url: 'http://www.baidu.com/xxx.png',
      },
      retro:{}
    },

    ModelloUnico: {
      unico:false
    },

  });


*/



  /*

  mock.onPost("/api/v0/preventivo/calcolo").reply(200, {
      tan: (Math.random() * 10).toFixed(2),
      taeg: (Math.random() * 10).toFixed(2),
      importoRata: Math.floor(Math.random() * 101).toFixed(2)
  });

  */


  /*
  mock.onPost("/api/v0/pratica//conferma").reply(200, {

    tmpCurrentStep: 0,
    confermaEmail:'',

    modello:{

    id: "12312",
    codiceBroker: 'COD21302',
    currentStep: 1,

    datiPratica:{

        importo:15000,
        numeroRate:48,
        assicurazione:true,
        progetto:"MOT",
        tan:6.77,
        taeg:3.66,
        rata:30.65,
      
        nome:'Matteo',
        cognome:'Marescotti',
        codiceFiscale:'MRSMTT96T14D548A',
        consensoMkt:false,
        consensoTerzi:true,
        consensoMarketing:false,
      

        email:'',
        confermaEmail:'',
        cellulare:'',
        telefono:'',
      
        correntistaCcb:null,
        iban:'',
 

        personaEsposta:null,

        cittadinanza:'',
        tipoPermessoSoggiorno:'',
        dataScadenzaSoggiorno:'',
   

        statoCivile:'',


        abitazione:"",
        importoAffitto:"",
        indirizzoResidenza:"",
        civico:"",
        cap:"",
        comune:"",
        provincia:"",
        tempoResidenza:"",
        indirizzoResidenzaPrecedente:"",
        civicoPrecedente:"",
        capPrecedente:"",
        comunePrecedente:"",
        provinciaPrecedente:"",
  

        documento:'',
        numeroDocumento:'',
        dataEmissioneDocumento:'',
        comuneEmissione:'',
        provinciaEmissione:"",
      
        
        attivita:'',
        occupazioneAutonomo:'',
        occupazioneDipendente:'',
        tipologiaPensione:"",
        dataInizioAttivita:"",
        dataFineAttivita:"",
        settoreAttivita:"",
        tipoContratto:"",
        ragioneSocialeAzienda:"",
        indirizzoResidenzaAzienda:"",
        capAzienda:"",
        comuneAzienda:"",
        provinciaAzienda:"",
        telefonoAzienda:"",


        redditoMensileNetto:"",
        redditoMensilita:"",
      

        domanda1:null,
        domanda2:null,
        domanda3:null,
        domanda4:null,
        domanda5:null,
        questionarioCompletato:null
    
    }

  },

    cartaIdentita: {
      unico:false,
      fronte: {
        uid: '1',
        name: 'fronte.png',
        status: 'error',
        response: 'Server Error 500', // custom error message to show
        url: 'http://www.baidu.com/xxx.png',
      },
      retro: {
        uid: '1',
        name: 'retro.png',
        status: 'done',
        response: '', 
        url: 'http://www.baidu.com/xxx.png',
      }
    },

    tesserinoSanitario: {
      unico:true,
      fronte: {
        uid: '1',
        name: 'unico.png',
        status: 'error',
        response: 'Server Error 500', // custom error message to show
        url: 'http://www.baidu.com/xxx.png',
      },
      retro:{}
    },

    ModelloUnico: {
      unico:false
    }
});

*/


/*
  mock.onGet("/api/v1/codiceFiscale").reply(200, {
      sesso: 'Uomo',
      comuneNascita:'Ferrara',
      provinciaNascita:'FE',
      dataNascita:'1996-12-14',
      esitoControllo:true,
      errorMessage:''
  });
  */

 /* mock.onGet("/api/v1/controlloTelefonoFisso").reply(200, {
    esitoControllo:true,
    errorMessage:''
  });

  */


  /*
  mock.onGet("/api/v1/controlloIban").reply(200, {
      banca:'MedioBanca',
      correntistaCcb:true,
      esitoControllo:true,
      errorMessage:''
  });
  */

  /*
  mock.onGet("/api/v0/controlloCittadinanza").reply(200, {
      esitoControllo:true,
      errorMessage:''
  });

  mock.onGet("/api/v0/controlloResidenza").reply(200, {
        comuni:"Ferrara,Bondeno,Migliarino,Copparo",
        provincia:'Ferrara',
        esitoControlloCAP:true,
        errorMessage:''
  });

  mock.onGet("/api/v0/controlloResidenzaPrecedente").reply(200, {
        comuni:"Bologna,San Pietro in Casale,Castel Maggiore,Pianoro",
        provincia:'Bologna',
        esitoControlloCAP:true,
        errorMessage:''
  });

  mock.onGet("/api/v0/listaProvinceDocumentoIdentificativo").reply(200, {
        province:"Ferrara,Modena,Cesena,Rimini,Piacenza,Parma,Reggio Emilia",
        esitoControllo:true,
        errorMessage:''
  });

  mock.onGet("/api/v0/listaComuniDocumentoIdentificativo").reply(200, {
        comuni:"Bologna,San Pietro in Casale,Castel Maggiore,Pianoro",
        esitoControllo:true,
        errorMessage:''
  });

  mock.onGet("/api/v1/controlloResidenzaAzienda").reply(200, {
        comuni:"Bologna,San Pietro in Casale,Castel Maggiore,Pianoro",
        provincia:'Bologna',
        esitoControlloCAP:true,
        errorMessage:''
  });

  */
 
}
/*
export default axios.create({
  baseURL: `/.rest/api/v1/`
});

*/

const getAxios = (url) => {
  return axios.create({
    baseURL: url || `/.rest/api/v1/`
  });
}

export default {getAxios};